import { IToast } from '@components/molecules/toast'
import { FixedActionTypes, FixedActions } from './types'

export const setToast = (toast: IToast): FixedActionTypes => ({
    type: FixedActions.SET_TOAST,
    payload: toast
})